import styled from 'styled-components';

import { Textarea } from 'components/shared/formControls';

const StyledTextarea = styled(Textarea)`
  margin-bottom: 0.3rem;
`;

export default StyledTextarea;
